import { InjectedStyledComponent } from '../../../../shared/InjectedStyledComponent.js';
import Button from '../../../base/Button/Button.js';
import { DOCUMENT_DOWNLOAD_CATEGORY_KEY, DOCUMENT_DOWNLOAD_COMPONENT_KEY } from '../DocumentDownload.meta.js';

export default InjectedStyledComponent(
	Button,
	DOCUMENT_DOWNLOAD_CATEGORY_KEY,
	DOCUMENT_DOWNLOAD_COMPONENT_KEY,
	['downloadButton'],
	// reset the button styles
	`padding: 0;
	margin: 0;
	border: none;
	background-color: transparent;
	color: inherit;`,
);
